<template>
  <div>
    <div v-if="$route.path.indexOf('_editor') === -1">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input placeholder="活动名称" v-model="params.title"><el-button slot="append" icon="el-icon-search" @click="dataSearch"></el-button></el-input>
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="create_time" type="daterange" value-format="yyyy/MM/dd" placeholder="添加时间筛选" style="width: 100%;" @change="dateChange"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" icon="plus" @click="addActivityData">添加活动</el-button>
        </el-col>
      </el-row>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>

        <el-table :data="activityLists" :height="wheight-200" v-loading="loading">
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="name" label="活动名称" min-width="180"></el-table-column>
          <el-table-column prop="banner" label="活动banner" min-width="100">
              <template slot-scope="scope">
                <el-popover
                        placement="right"
                        width="240"
                        trigger="hover" >
                  <img  :src="wximageurl + scope.row.banner" style="width:100%;">
                  <el-button type="text" slot="reference"><img style="width:50px;height:50px;" :src="wximageurl + scope.row.banner" ></el-button>
                </el-popover>
              </template>
          </el-table-column>
          <el-table-column label="活动时间" min-width="150">
            <template slot-scope="scope">
              <div> {{scope.row.start_time | datetime('yyyy-MM-dd hh:mm:ss')}}</div>
              <div>~</div>
              <div>{{scope.row.end_time | datetime('yyyy-MM-dd hh:mm:ss')}}</div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <el-button type="text" @click="editAction(scope.$index, scope.row)">编辑活动</el-button>
              <el-button type="text" @click="setActivityUsers(scope.row)">设置参与人员</el-button>
              <el-button type="text" @click="getActivityUsers(scope.row)">领取记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="total_count > params.pageSize" class="content-center content-top-padded">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-sizes="[10,20,50]"
            :current-page.sync="params.page"
            :total="total_count" :page-size="params.pageSize">
          </el-pagination>
        </div>
      </el-tabs>
    </div>

    <el-dialog title="活动支持店铺列表" :visible.sync="dialogVisible" width="50%">
      <el-table :data="distributors.distributor_info" :height="wheight-500" v-loading="loading">
        <el-table-column prop="name" label="店铺名称" min-width="180"></el-table-column>
        <el-table-column prop="address" label="地址" min-width="180"></el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button type="text" @click="uploadActionWxaCode(scope.$index, distributors, scope.row.distributor_id)">下载小程序码</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'
import { getDefaultCurrency } from '../../../../api/company'
import { getGiftsActivitysList, seckillActivityUpdateStatus, buyOnesFreeOnesGetList, seckillActivityWxcode,changeShowOne,updatebuyOnesFreeOnes} from '../../../../api/promotions'
export default {
  props: ['getStatus'],
  provide() {
    return {
      refresh: this.refresh
    }
  },
  data () {
    return {
      create_time: '',
      activeName: 'all',
      activityLists: [],
      downloadfilename: '',
      downloadUrl: '',
      loading: false,
      total_count: 0,
      params: {
        page: 1,
        pageSize: 20,
        status: '',
        title: '',
        begin_time: '',
        end_time: '',
      },
      communityVisible: false,
      couponVisible: false,
      goodsVisible: false,
      goodsList: [],
      goodsCount: 0,
      distributors: [],
      goodsPageSize: 10,
      goodsPage:1,
      nowActivity: '',
      cursymbol: '',
      dialogVisible: false,
      currency: {}
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {

    handleClick(tab, event) {
      this.activeName = tab.name
      this.params.status = tab.name == 'all' ? '' : tab.name
      this.params.page = 1
      this.getActivityLists()
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.pageSize = pageSize
      this.getActivityLists()
    },
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getActivityLists()
    },
    addActivityData () { // 添加物料弹框
      this.$router.push({path: this.matchHidePage('editor')})
    },
    editAction (index, row) { // 编辑物料弹框
      this.$router.push({path: this.matchHidePage('editor/') + row.id})
    },
    setActivityUsers(index){
      // 设置活动参与人
        this.$router.push({path:'/marketing/giftsActivitys/giftsActivitysusers',query:{activity_id:index.id}})
    },
    getActivityUsers(index){
        // 获取领取商品订单
        this.$router.push({path:'/marketing/giftsActivitys/GiftsActivitys_order',query:{activity_id:index.id}})
    },
    copyAction (index, row) { // 复制活动
     // this.$router.push({path: this.matchHidePage('editor/') + row.seckill_id})
      this.$router.push({path: this.matchHidePage('editor/?copy_seckill_id=') + row.seckill_id})
    },
    changeShow(index, id){
      var msg = '确定隐藏, 是否继续?'
      this.$confirm(msg, '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            changeShowOne({seckill_id:id}).then(response => {
              if(response.data.data.status==1){
                this.$message({
                  message: response.data.data.message,
                  type: 'success',
                  duration: 2000
                })
                this.getActivityLists()
              }else{
                this.$message({
                  message: response.data.data.message,
                  type: 'error',
                  duration: 2000
                })
              }
            })
          }
          done()
        }
      })
    },
    dataSearch() {
      this.params.begin_time = ''
      this.params.end_time = ''
      this.params.page = 1
      this.getActivityLists()
    },
    getActivityLists () {
      this.loading = true
        getGiftsActivitysList(this.params).then(response => {
        this.activityLists = response.data.data.list
        this.total_count = response.data.data.total_count
        this.loading = false
      })
    },
    dateChange (val) {
      this.params.status = ''
      if (val && val.length > 0) {
        this.params.begin_time = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.end_time = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.begin_time = ''
        this.params.end_time = ''
      }
      this.params.page = 1
      this.getActivityLists()
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    },
    viewCouponList(ids){
      this.couponVisible = true
    },
    handleCancel () {
      this.communityVisible = false
      this.couponVisible = false
      this.goodsVisible = false
    },
    getCurrencyInfo() {
      getDefaultCurrency().then(res => {
        this.currency = res.data.data
        this.cursymbol = this.currency.symbol
      })
    },
    updateActivityData(params) {
      updateActivityItemData(params).then(res => {

      })
    },

    refresh () {
      this.getActivityLists()
      this.getCurrencyInfo()
    }
  },
  mounted () {
    this.getActivityLists()
    this.getCurrencyInfo()
  },
  watch: {
    getStatus (val) {
      if (val) {
        this.getActivityLists()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.icon-search-plus {
  cursor: pointer;
}
.text-muted {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// list.vue?03c068c0